import { Box, ModalCloseButton as ChakraCloseButton } from '@chakra-ui/react';
import React from 'react';
import CloseIcon from '../../icons/CloseIcon/CloseIcon';
import { useTokens } from '../../../context/TokenProvider';
const StandardModalCloseButton = ({ label, testId }) => {
    const tokens = useTokens();
    const focusStyles = {
        _focus: {
            outlineColor: tokens.BorderFocus,
            outlineWidth: tokens.BorderWidth02,
            borderColor: tokens.BorderDark800,
            bgColor: tokens.Layer01,
            background: tokens.Layer01,
            boxShadow: 'none',
        },
    };
    return (React.createElement(Box, { marginLeft: "auto" },
        React.createElement(ChakraCloseButton, { "data-testid": testId ?? 'standard_modal_close_button', position: "static", "aria-label": label, sx: focusStyles },
            React.createElement(CloseIcon, null))));
};
export default StandardModalCloseButton;
